export function getAnimalEmoji(animalType: string): string {
  return animalType?.toLowerCase() === 'dog' ? '🐶' : '🐱';
}

export function a11yProps(index: number) {
  return {
    id: `pet-tab-${index}`,
    'aria-controls': `pet-tabpanel-${index}`,
  };
}

export function formatPromptDate(dateString: string): string {
  const date = new Date(dateString);
  const now = new Date();
  const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());

  const options: Intl.DateTimeFormatOptions = {
    month: 'long',
    day: 'numeric',
  };

  if (date < oneYearAgo) {
    options.year = 'numeric';
  }

  return date.toLocaleDateString('en-US', options);
}
